import { makeGetters, makeSetters } from '@/utils/vuex-helper';

const state = {
  isRestrictFunc: false,
  restrictFuncInfo: {
    id: '',
    name: '',
    message: ''
  }
};

const getters = {
  ...makeGetters(['isRestrictFunc', 'restrictFuncInfo'])
};

const actions = {};

const mutations = {
  ...makeSetters(['isRestrictFunc', 'restrictFuncInfo'])
};

export default {
  state,
  getters,
  actions,
  mutations
};
